/* eslint-disable camelcase */

import React from 'react';
import { pure } from 'recompose';

import Heading from 'app/ui/heading';

import { appSizeType } from 'app/pages/app/app.types';
import {
  name as nameType,
  released as releasedType,
  platforms as platformsType,
  parent_platforms as parent_platforms_type,
  playtime as playtimeType,
  promo as promoType,
} from 'app/pages/game/game.types';
import config from 'config/config';

import GameHeadMeta from 'app/ui/game-head-meta';

const gameHeadBlockPropertyTypes = {
  size: appSizeType.isRequired,
  name: nameType,
  released: releasedType,
  platforms: platformsType,
  parent_platforms: parent_platforms_type,
  playtime: playtimeType,
  promo: promoType,
};

const gameHeadBlockDefaultProperties = {
  platforms: [],
  parent_platforms: [],
  released: '',
  playtime: 0,
  name: '',
  promo: '',
};

const GameHeadBlock = ({ size, name, released, platforms, parent_platforms, playtime, promo }) => {
  const e3 = config.promos.e3 && promo === 'e3';
  const gc = config.promos.gamescom && promo === 'gamescom';

  return (
    <div className="game__head">
      <GameHeadMeta
        appSize={size}
        released={released}
        platforms={platforms}
        parentPlatforms={parent_platforms}
        playtime={playtime}
      />
      {e3 && <div className="game__head-e3-2018-promo" />}
      {gc && <div className="game__head-gamescom-promo" />}
      <Heading itemProp="name" className="game__title" rank={1}>
        {name}
      </Heading>
    </div>
  );
};

GameHeadBlock.propTypes = gameHeadBlockPropertyTypes;
GameHeadBlock.defaultProps = gameHeadBlockDefaultProperties;

export default pure(GameHeadBlock);
